import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProducerUrl } from './useProducerUrl';

interface NavigationHelpers {
  navigateToProducts: () => void;
  navigateToShoppingCart: () => void;
  navigateToOffers: () => void;
  navigateToMyOrders: () => void;
}

export const useAppNavigation = (): NavigationHelpers => {
  const navigate = useNavigate();
  const producerUrl = useProducerUrl();

  const navigateToProducts = useCallback(() => {
    navigate(`/${producerUrl}/products`);
  }, [navigate, producerUrl]);

  const navigateToShoppingCart = useCallback(() => {
    navigate(`/${producerUrl}/shopping-cart`);
  }, [navigate, producerUrl]);

  const navigateToOffers = useCallback(() => {
    navigate(`/${producerUrl}/my-offers`);
  }, [navigate, producerUrl]);

  const navigateToMyOrders = useCallback(() => {
    navigate(`/${producerUrl}/my-orders`);
  }, [navigate, producerUrl]);

  return {
    navigateToProducts,
    navigateToShoppingCart,
    navigateToOffers,
    navigateToMyOrders,
  };
};
